"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const teamsnap_ui_1 = require("@teamsnap/teamsnap-ui");
const form_field_element_1 = __importDefault(require("components/form/form-field-element"));
const constants_1 = require("core/constants");
const React = __importStar(require("react"));
const redux_form_1 = require("redux-form");
class LoginFormFields extends React.Component {
    render() {
        const { disabled, userHasTs1, email } = this.props;
        const ts1Url = userHasTs1 ? new URL(constants_1.IDENTITY_URL) : null;
        if (ts1Url) {
            ts1Url.pathname = '/settings';
        }
        return (React.createElement("div", null,
            React.createElement("div", { className: "Panel-row Grid u-padNone" },
                React.createElement("div", { className: "Grid-cell Panel-cell Panel-cell--header u-size6of24" },
                    React.createElement("label", { className: "FieldGroup-label", htmlFor: "email" },
                        React.createElement("h4", null, "Email"))),
                React.createElement("div", { className: "Grid-cell Panel-cell u-size18of24" },
                    React.createElement(redux_form_1.Field, { name: "email", component: form_field_element_1.default, type: "email", disabled: disabled }),
                    React.createElement("small", { className: "field-info" }, "Used for login and billing"))),
            React.createElement("div", { className: "Panel-row Grid u-padNone" },
                React.createElement("div", { className: "Grid-cell Panel-cell Panel-cell--header u-size6of24" },
                    React.createElement("label", { className: "FieldGroup-label", htmlFor: "currentPassword" },
                        React.createElement("h4", null, "Current Password"))),
                React.createElement("div", { className: "Grid-cell Panel-cell u-size18of24" }, ts1Url ? (React.createElement("span", { className: "sui-flex sui-items-center sui-justify-between" },
                    React.createElement("p", { className: "sui-mb-0 sui-flex-1 sui-caption" }, "To change your password, go to your TeamSnap ONE account"),
                    React.createElement(teamsnap_ui_1.Button, { color: "primary u-sizesm", onClick: () => window.open(ts1Url.toString(), '_blank', 'noopener,noreferrer') }, "Update on TeamSnap ONE"))) : (React.createElement(React.Fragment, null,
                    React.createElement(redux_form_1.Field, { name: "currentPassword", component: form_field_element_1.default, type: "password", disabled: disabled }),
                    React.createElement("small", { className: "field-info" }, "Required when changing password"))))),
            !ts1Url && (React.createElement("div", { className: "Panel-row Grid u-padNone" },
                React.createElement("div", { className: "Grid-cell Panel-cell Panel-cell--header u-size6of24" },
                    React.createElement("label", { className: "FieldGroup-label", htmlFor: "password" },
                        React.createElement("h4", null, "New Password"))),
                React.createElement("div", { className: "Grid-cell Panel-cell u-size18of24" },
                    React.createElement(redux_form_1.Field, { name: "password", component: form_field_element_1.default, type: "password", disabled: disabled })))),
            !ts1Url && (React.createElement("div", { className: "Panel-row Grid u-padNone" },
                React.createElement("div", { className: "Grid-cell Panel-cell Panel-cell--header u-size6of24" },
                    React.createElement("label", { className: "FieldGroup-label", htmlFor: "passwordConfirmation" },
                        React.createElement("h4", null, "Confirm Password"))),
                React.createElement("div", { className: "Grid-cell Panel-cell u-size18of24" },
                    React.createElement(redux_form_1.Field, { name: "passwordConfirmation", component: form_field_element_1.default, type: "password", disabled: disabled }))))));
    }
}
exports.default = LoginFormFields;
